import { SxProps, Theme } from '@mui/material';

export const rootStyles: SxProps<Theme> = theme => ({
  gap: theme.spacing(4.5),
});

export const labelStyles: SxProps<Theme> = {
  root: theme => ({
    gap: theme.spacing(2.5),
  }),
  label: theme => ({
    color: theme.palette.grey[700],

    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
  }),
};

export const radioStyles: SxProps<Theme> = {
  width: 20,
  height: 20,
};
